module.exports = __webpack_public_path__ + "static/media/backgroundDark.35079e87.png";